import { NgModule } from "@angular/core";
import { AgendaService, TimelineMonthService, TimelineViewsService, MonthAgendaService, DayService, MonthService, WeekService, WorkWeekService, ScheduleModule, ScheduleAllModule, RecurrenceEditorModule, ResizeService } from "@syncfusion/ej2-angular-schedule";
import { RichTextEditorAllModule, ToolbarService, HtmlEditorService, PasteCleanupService, TableService, ImageService, LinkService, QuickToolbarService, RichTextEditorModule, CountService, MarkdownEditorService, FileManagerService, FormatPainterService, EmojiPickerService } from '@syncfusion/ej2-angular-richtexteditor'
import { ButtonModule, CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { MultiSelectModule, DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { AppBarModule, ToolbarModule, ContextMenuModule } from '@syncfusion/ej2-angular-navigations';
import { CalendarModule, DatePickerModule, TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { MessageModule, ToastModule } from '@syncfusion/ej2-angular-notifications';
import { DropDownButtonModule } from '@syncfusion/ej2-angular-splitbuttons'
import { NumericTextBoxModule, SignatureAllModule, SignatureModule, TextBoxModule } from "@syncfusion/ej2-angular-inputs";
import { SwitchModule } from "@syncfusion/ej2-angular-buttons";

@NgModule({
    imports: [
        ScheduleModule,
        RichTextEditorAllModule,
        RichTextEditorModule,
        AppBarModule, 
        ButtonModule, 
        ToolbarModule, 
        CheckBoxModule, 
        ContextMenuModule, 
        MultiSelectModule, 
        DropDownListModule, 
        TimePickerModule,
        ScheduleAllModule,
        RecurrenceEditorModule,
        ToastModule,
        CalendarModule,
        DatePickerModule,
        DropDownButtonModule,
        SignatureAllModule, 
        SignatureModule,
        MessageModule,
        TextBoxModule,
        NumericTextBoxModule,
        SwitchModule
    ],
    exports: [
        ScheduleModule,
        RichTextEditorAllModule,
        RichTextEditorModule,
        AppBarModule, 
        ButtonModule, 
        ToolbarModule, 
        CheckBoxModule, 
        ContextMenuModule, 
        MultiSelectModule, 
        DropDownListModule, 
        TimePickerModule,
        ScheduleAllModule,
        RecurrenceEditorModule,
        ToastModule,
        CalendarModule,
        DatePickerModule,
        DropDownButtonModule,
        SignatureAllModule, 
        SignatureModule,
        MessageModule,
        TextBoxModule,
        NumericTextBoxModule,
        SwitchModule
    ],
    providers: [
        DayService,
        WeekService,
        WorkWeekService,
        MonthService,
        AgendaService,
        MonthAgendaService,
        TimelineViewsService,
        TimelineMonthService,
        ToolbarService,
        HtmlEditorService,
        LinkService,
        ImageService,
        TableService,
        QuickToolbarService,
        PasteCleanupService,
        CountService,
        MarkdownEditorService,
        ResizeService,
        FileManagerService,
        FormatPainterService,
        EmojiPickerService
    ],
})
export class SyncfusionModule { }